<script setup>
const downloadAnZhuo = () => {
  window.open('https://static.idicc.cn/cdn/aiApp/airApp.apk')
}
const downloadIos = () => {
  // showToast('敬请期待~')
  window.open('https://apps.apple.com/cn/app/id6737882470')
}
</script>

<template>
  <div class="onLineAndOffLinePart w-full flex items-center justify-center px-4">
    <div class="bg-left-right ">
      <div class="w-full ">
        <div class="text-[36px] text-[#333] font-bold">
          移动端下载
        </div>
        <div class="flex items-center mt-4 text-[28px] text-[#333]">
          哒达招商下载
          <img
            class="w-[32px] h-[32px] ml-3"
            src="https://static.idicc.cn/cdn/official/H5/home_down.png"
            alt=""
          >
        </div>
        <div class="text-[24px] text-[#666] mt-3">
          提供一站式招商项目管理，全链条闭环线上招商平台
        </div>
        <div class="flex items-center mt-6">
          <div class="flex items-center text-[#333333] text-[28px] bg-[#E0E6F6] rounded-[8px] px-3 py-1" @click="downloadAnZhuo">
            <img
              class="w-[32px] h-[32px] mr-2"
              src="https://static.idicc.cn/cdn/official/H5/home_android.png"
              alt=""
            >
            安卓手机下载
          </div>
          <div class="flex items-center text-[#333333 text-[28px] bg-[#E0E6F6] rounded-[8px] px-3 py-1 ml-5" @click="downloadIos">
            <img
              class="w-[32px] h-[32px] mr-2"
              src="https://static.idicc.cn/cdn/official/H5/home_apple.png"
              alt=""
            >
            苹果手机下载
          </div>
        </div>
        <div class="w-full flex items-center flex-col">
          <img
            class="w-[540px] h-[494px] mt-8"
            src="https://static.idicc.cn/cdn/official/H5/home_app.png"
            alt=""
          >
          <div class="text-[28px] text-[#333] font-bold mt-8">
            哒达出海小程序
          </div>
          <div class="text-[24px] text-[#666] mt-4">
            AI护航企业出海，解决「了解·决策·落地」三大需求
          </div>
          <img
            class="w-[240px] h-[240px] mt-6 bg-[#A3AED0] rounded-xl"
            src="https://static.idicc.cn/cdn/official/H5/xcx_sea.png"
            alt=""
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.onLineAndOffLinePart {
  width: 100vw;
  margin-top: 80px;
  margin-bottom: 65px;
  .bg-left-right {
    width: 100%;
     height: 100%;
  }
}
</style>
